import React from 'react';
import styles from './landingFaq.module.css';

interface FaqHeaderProps {
  title: string;
}

const FaqHeader: React.FC<FaqHeaderProps> = ({ title }) => (
  <h2 className={styles.header}>{title}</h2>
);

export default FaqHeader;
